module.exports = __webpack_public_path__ + "static/media/YF76_04.9bae7b7f.jpg";